const pathRoutes = {
  ROOT_LOGIN: "/",
  ROOT_PASSWORD_RESET: "/password-reset",
  ROOT_PASSWORD_RESET_FORM: "/password-reset-form/:token",
  PORTAL: "/portal",
  ADMIN: "/admin",
};

const pathPortal = {
  PORTAL_SAMPLES: pathRoutes.PORTAL + "/muestras",
};

const pathAdmin = {
  ADMIN_USUARIOS: pathRoutes.ADMIN + "/usuarios",
  ADMIN_INFORMES: pathRoutes.ADMIN + "/informes",
  ADMIN_INCERTIDUMBRES: pathRoutes.ADMIN + "/incertidumbres",
  ADMIN_CALIBRACIONES: pathRoutes.ADMIN + "/calibraciones",
  ADMIN_FONDOS: pathRoutes.ADMIN + "/fondos",
  ADMIN_TRANSIT: pathRoutes.ADMIN + "/transito",
  ADMIN_MASTER_TABLES: pathRoutes.ADMIN + "/tablas-maestras",
  ADMIN_DEBUG: pathRoutes.ADMIN + "/debug",
};

const routes = {
  ...pathRoutes,
  ...pathPortal,
  ...pathAdmin,
};

export default routes;
